import type * as React from 'react';

export const getDivRefPosition = (
  divRef: React.RefObject<HTMLDivElement>,
  position: keyof Omit<DOMRectReadOnly, 'toJSON'>,
): number => divRef?.current?.getBoundingClientRect()[position] || 1;
